import React from "react"
import { Button, ButtonGroup, Dropdown, DropdownButton, Form, FormGroup, Table } from "react-bootstrap"
import { CaretDownFill, CaretUpFill, CheckSquareFill, Dash, X } from "react-bootstrap-icons"
import { Field } from "formik"
import Select from "react-select"
import * as CountryIcon from "country-flag-icons/react/3x2"
import { getBinaryFile } from "../js/api_common"
import withHooks from "./WithHooks"

class TableOfEntities extends React.Component {
  constructor(props) {
    super(props)

    this.dMgr = this.props.DebugManager(this.constructor.name)
    // this.dMgr.activate(true)
    this.dMgr.debug("const_props:", this.props)

    let buttonsStates = {}
    this.props.rows.forEach((row, index) => {
      buttonsStates[index] = {}
      row.fields.forEach((field, index2) => {
        if (field.name === "actions") {
          field.actions.forEach((buttonName, index3) => {
            if (buttonName === "downloadPdfVersionLang" || buttonName === "downloadPdfLang") {
              buttonsStates[index][buttonName] = {
                langFlag: this.props.i18n.options.availableLanguages[this.props.i18n.resolvedLanguage].flag,
                lang: this.props.i18n.resolvedLanguage,
              }
            }
          })
        }
      })
    })

    this.state = {
      downloading: false,
      buttonsStates: buttonsStates,
      addXElementsInLineNumber: -1,
    }
    this.dMgr.debug("init_state:", this.state)
  }

  render() {
    this.dMgr.rendering()
    this.dMgr.debug("this.props.rows.length:", this.props.rows.length)

    let toRender = (
      <Table
        striped={this.props.striped === undefined ? true : this.props.striped}
        bordered
        hover={this.props.hover === undefined ? true : this.props.hover}
        variant="dark"
        key={this.props.tableName}
        id={this.props.tableName}
      >
        <thead>
          <tr>
            {this.props.headers.map((header, index) => {
              let classNames = []
              if (header.className !== undefined) {
                classNames.push(header.className)
              }
              if (header.sort !== undefined) {
                classNames.push("th-sortable")
              }
              if (header.name === "actions") {
                classNames.push("text-center")
              }

              return (
                <th
                  key={"th_" + this.props.tableName + "_" + index}
                  className={classNames.join(" ")}
                  onClick={() => {
                    if (header.sort !== undefined) {
                      this.props.listOrdersUpdate(header.name)
                    }
                  }}
                >
                  {header.title}
                  {header.sort !== undefined ? (
                    <span className="vertical-align-middle">
                      {" "}
                      {header.sort === "asc" ? (
                        <CaretUpFill className="order-caret margin-left-8" />
                      ) : header.sort === "desc" ? (
                        <CaretDownFill className="order-caret margin-left-8" />
                      ) : (
                        <Dash className="order-caret margin-left-8" />
                      )}
                    </span>
                  ) : (
                    ""
                  )}
                </th>
              )
            })}
          </tr>
        </thead>
        <tbody>
          {this.props.rows.length === 0 ? (
            <tr>
              <td colSpan={this.props.headers.length} className="text-center">
                {this.props.t("entity." + this.props.entitiesType)} {this.props.t("message.notFound").toLowerCase()}
              </td>
            </tr>
          ) : (
            this.props.rows.map((row, index) => {
              this.dMgr.debug("row:", row)

              return (
                <tr key={"tr_" + this.props.tableName + "_" + index}>
                  {row.fields.map((field, index2) => {
                    this.dMgr.debug("field:", field)

                    let entity = row.entity
                    let classNames = []
                    let isDeleted = entity.isVisible !== undefined && !entity.isVisible
                    if (isDeleted) {
                      classNames.push("text-danger")
                    }
                    classNames.push("vertical-align-middle")

                    if (field.className !== undefined) {
                      classNames.push(field.className)
                    }

                    let value = []
                    if (field.name !== "actions") {
                      if (field.type === undefined) {
                        field.type = "display-value"
                      }

                      this.dMgr.debug("field.type:", field.type)

                      if (field.type === "display-value") {
                        if (field.value !== undefined) {
                          if (field.link !== undefined) {
                            field.value = (
                              <a
                                className="light"
                                href=""
                                onClick={(e) => {
                                  e.preventDefault()
                                  this.props.router.nav({
                                    url: field.link.url,
                                    referrerUrl: field.link.referrerUrl,
                                  })
                                }}
                              >
                                {field.value}
                              </a>
                            )
                          }

                          if (typeof field.value == "boolean") {
                            if (field.value) {
                              value.push(<CheckSquareFill />)
                            } else {
                              value.push(<X />)
                            }
                          } else if (!Array.isArray(field.value)) {
                            value.push(field.value)
                          } else {
                            value = field.value
                          }

                          if (field.valueSuffix !== undefined) {
                            value.push(String(field.valueSuffix))
                          }
                        }
                      } else if (field.type === "input-text" || field.type === "input-number") {
                        // console.log("errmessag", field.errorMessage)
                        // console.log("input-text id", this.props.tableName + "_" + entity.id + "_" + index + "_" + index2)
                        // console.log("field.value", field.value)

                        value.push(
                          <>
                            <Field
                              id={this.props.tableName + "_" + entity.id + "_" + index + "_" + index2}
                              key={this.props.tableName + "_" + entity.id + "_" + index + "_" + index2}
                              as={Form.Control}
                              name={field.name}
                              type={field.type === "input-number" ? "number" : "text"}
                              isInvalid={field.errorMessage !== undefined}
                              onChange={(e) => {
                                // console.log("change input", e)
                                this.props.handleChange(e, entity)
                              }}
                              tabIndex={field.tabIndexCount === true ? index + 1 : 0}
                              value={field.value}
                              min={field.mbgalue}
                            />
                            <Form.Control.Feedback type="bgalid">{field.errorMessage !== undefined ? field.errorMessage[field.name] : null}</Form.Control.Feedback>
                          </>,
                        )
                      } else if (field.type === "input-checkbox") {
                        value.push(
                          <Form.Check
                            id={this.props.tableName + "_" + entity.id + "_" + index + "_" + index2}
                            key={this.props.tableName + "_" + entity.id + "_" + index + "_" + index2}
                            name={field.name}
                            type="checkbox"
                            checked={field.value}
                            onChange={(e) => {
                              console.log("change input", e.target.checked, e)
                              this.props.handleChange(
                                {
                                  target: {
                                    name: field.name,
                                    value: e.target.checked,
                                  },
                                },
                                entity,
                              )
                            }}
                          />,
                        )
                      } else if (field.type === "input-select") {
                        // console.log("errmessag", field.errorMessage)
                        // console.log("field.value", entity.id)

                        // this.dMgr.debug("input-select ", field)

                        // console.log("field.value", field.value)

                        value.push(
                          <Form.Group>
                            <Select
                              id={this.props.tableName + "_" + entity.id + "_" + index + "_" + index2}
                              classNamePrefix="custom-react-select"
                              className={`react-select ${field.errorMessage ? "react-select-bgalid" : ""}`}
                              key={this.props.tableName + "_" + entity.id + "_" + index + "_" + index2}
                              placeholder={this.props.t("message.pleaseSelectAnOption")}
                              name={field.name}
                              onChange={(e) => {
                                this.props.handleChange(
                                  {
                                    target: {
                                      name: field.name,
                                      value: e.value,
                                    },
                                  },
                                  entity,
                                )
                              }}
                              options={field.options.map((option) => {
                                return {
                                  value: option,
                                  label: option[field.labelKey],
                                }
                              })}
                              defaultValue={
                                field.value !== undefined
                                  ? {
                                      value: field.value,
                                      label: field.value[field.labelKey],
                                    }
                                  : ""
                              }
                            />
                            {field.errorMessage && <div className="bgalid-feedback d-block">{field.errorMessage}</div>}
                          </Form.Group>,
                        )
                      }
                    } else if (field.name === "actions") {
                      if (field.actions.length === 0) {
                        classNames.push("text-center")
                        value = ["/"]
                      } else {
                        classNames.push("text-end")
                        classNames.push("width-1")
                        classNames.push("white-space-nowrap")
                        value = field.actions.map((buttonName, index3) => {
                          const btnKey = this.props.tableName + "_btnkey_" + index + "_" + index2 + "_" + index3

                          if (field.extraButtons !== undefined && field.extraButtons[buttonName] !== undefined && field.extraButtons[buttonName].isVisible === false) {
                            return null
                          }

                          // console.log(btnKey)
                          if (buttonName === "addInLine") {
                            // console.log("btn id ", btnKey)
                            return (
                              <Button id={btnKey} key={btnKey} onClick={() => this.props.addInLineEntity(this.state.addXElementsInLineNumber)} variant="primary" size="sm" className="margin-right-5">
                                {field.label !== undefined ? field.label : this.props.t("action.add")}
                              </Button>
                            )
                          } else if (buttonName === "addXElementsInLine") {
                            return (
                              <FormGroup>
                                <Button
                                  id={btnKey}
                                  key={btnKey}
                                  onClick={() =>
                                    this.props.addInLineEntity(
                                      field.defaultAddNumber !== undefined && this.state.addXElementsInLineNumber === -1 ? field.defaultAddNumber : this.state.addXElementsInLineNumber,
                                    )
                                  }
                                  variant="primary"
                                  size="sm"
                                  className="margin-right-5"
                                >
                                  {field.label !== undefined ? field.label : this.props.t("action.add")}
                                </Button>
                                <Field
                                  className="width-70 display-inline"
                                  as={Form.Control}
                                  type="number"
                                  name="addXElementsInLineTextNumber"
                                  onChange={(e) => {
                                    this.setState({ addXElementsInLineNumber: parseInt(e.target.value) })
                                  }}
                                  value={field.defaultAddNumber !== undefined && this.state.addXElementsInLineNumber === -1 ? field.defaultAddNumber : this.state.addXElementsInLineNumber}
                                  min={1}
                                />
                              </FormGroup>
                            )
                          } else if (!isDeleted && buttonName === "edit") {
                            return (
                              <Button
                                key={btnKey}
                                onClick={() =>
                                  this.props.router.nav({
                                    prefix: "admin",
                                    entitiesType: this.props.entitiesType,
                                    actionName: "edit",
                                    entityId: entity.id,
                                    referrerUrl: this.props.referrerUrl,
                                  })
                                }
                                variant="warning"
                                size="sm"
                                className="margin-right-5"
                              >
                                {this.props.t("action.edit")}
                              </Button>
                            )
                          } else if (!isDeleted && buttonName === "delete") {
                            return (
                              <Button
                                key={btnKey}
                                onClick={() => {
                                  this.props.showModal({
                                    type: "confirmDelete",
                                    deleteEntity: entity,
                                    handleDelete: () => {
                                      this.props.deleteEntity(entity, () => {
                                        this.props.hideModal()
                                      })
                                    },
                                  })
                                }}
                                variant="danger"
                                size="sm"
                                className="margin-right-5"
                              >
                                {this.props.t("action.delete")}
                              </Button>
                            )
                          } else if (!isDeleted && buttonName === "deleteInline") {
                            return (
                              <Button
                                key={btnKey}
                                onClick={() => {
                                  this.props.showModal({
                                    type: "confirmDelete",
                                    deleteEntity: this.props.entity,
                                    modalConfirmDeleteBody: this.props.t("message.deleteThis") + " " + this.props.t("entity." + entity.entityType) + " " + this.props.t("app.qm"),
                                    handleDelete: () =>
                                      this.props.deleteInlineEntity(entity, index, index2, () => {
                                        this.props.hideModal()
                                      }),
                                  })
                                }}
                                variant="danger"
                                size="sm"
                                className="margin-right-5"
                              >
                                {this.props.t("action.delete")}
                              </Button>
                            )
                          } else if (isDeleted && buttonName === "restore") {
                            return (
                              <Button key={btnKey} onClick={() => this.props.restoreEntity(entity)} variant="secondary" size="sm" className="margin-right-5">
                                {this.props.t("action.restore")}
                              </Button>
                            )
                          } else if (buttonName === "downloadPdfLang") {
                            let IconCountry = CountryIcon[this.state.buttonsStates[index][buttonName].langFlag]

                            return (
                              <ButtonGroup className="margin-right-5" key={btnKey}>
                                <Button
                                  key={btnKey + "_btn"}
                                  variant="primary"
                                  size="sm"
                                  onClick={() => {
                                    this.setState({ downloading: true }, () => {
                                      Promise.all([
                                        getBinaryFile(
                                          field.extraButtons[buttonName].baseUrl + "/" + entity.id + "/" + this.state.buttonsStates[index][buttonName].lang,
                                          field.extraButtons[buttonName].baseFilename + "_" + entity.id + "_" + this.state.buttonsStates[index][buttonName].lang + ".pdf",
                                        ),
                                      ]).then(() => {
                                        this.setState({ downloading: false })
                                      })
                                    })
                                  }}
                                  disabled={this.state.downloading}
                                >
                                  {this.props.t("action.pdf")} <IconCountry className="lang_flag margin-left-5" />
                                </Button>

                                <DropdownButton
                                  key={btnKey + "_flag"}
                                  variant="primary"
                                  size="sm"
                                  data-bs-theme="dark"
                                  as={ButtonGroup}
                                  title=""
                                  className="margin-right-5 flag-dropdown"
                                  disabled={this.state.downloading}
                                >
                                  {Object.keys(this.props.i18n.options.availableLanguages)
                                    .filter((key) => {
                                      return key !== this.state.buttonsStates[index][buttonName].lang
                                    })
                                    .map((key) => {
                                      let IconCountry = CountryIcon[this.props.i18n.options.availableLanguages[key].flag]
                                      return (
                                        <Dropdown.Item
                                          key={btnKey + "_flag_" + key}
                                          onClick={() => {
                                            let buttonsStates = { ...this.state.buttonsStates }
                                            buttonsStates[index][buttonName].langFlag = this.props.i18n.options.availableLanguages[key].flag
                                            buttonsStates[index][buttonName].lang = key

                                            this.setState({ downloading: true, buttonsStates: buttonsStates }, () => {
                                              Promise.all([
                                                getBinaryFile(
                                                  field.extraButtons[buttonName].baseUrl + "/" + entity.originId + "/" + entity.versionNumber + "/" + this.state.buttonsStates[index][buttonName].lang,
                                                  field.extraButtons[buttonName].baseFilename + "_" + entity.id + "_" + this.state.buttonsStates[index][buttonName].lang + ".pdf",
                                                ),
                                              ]).then(() => {
                                                this.setState({ downloading: false })
                                              })
                                            })
                                          }}
                                        >
                                          {<IconCountry className="lang_flag" />}
                                        </Dropdown.Item>
                                      )
                                    })}
                                </DropdownButton>
                              </ButtonGroup>
                            )
                          } else if (field.extraButtons !== undefined && field.extraButtons[buttonName] !== undefined) {
                            if (!isDeleted || (field.extraButtons[buttonName].isAllowedOnDeleted !== undefined && field.extraButtons[buttonName].isAllowedOnDeleted)) {
                              if (field.extraButtons[buttonName].isVisible === undefined || field.extraButtons[buttonName].isVisible) {
                                return (
                                  <Button
                                    key={btnKey}
                                    onClick={() => {
                                      if (field.extraButtons[buttonName].confirmationRequired) {
                                        this.props.showModal({
                                          type: "confirm",
                                          entity: entity,
                                          confirmMessage: field.extraButtons[buttonName].confirmMessage,
                                          handle: () => {
                                            field.extraButtons[buttonName].onClickHandler(this.props.hideModal)
                                          },
                                        })
                                      } else {
                                        field.extraButtons[buttonName].onClickHandler()
                                      }
                                    }}
                                    variant={field.extraButtons[buttonName].variant !== undefined ? field.extraButtons[buttonName].variant : "primary"}
                                    size={field.extraButtons[buttonName].size !== undefined ? field.extraButtons[buttonName].size : "sm"}
                                    className={(field.extraButtons[buttonName].className !== undefined ? field.extraButtons[buttonName].className : "") + " margin-right-5"}
                                  >
                                    {field.extraButtons[buttonName].label !== undefined ? field.extraButtons[buttonName].label : "missing label"}
                                  </Button>
                                )
                              }
                            }
                          }
                          return ""
                        })
                      }
                    }

                    return (
                      <td
                        key={this.props.tableName + "_td_" + index + "_" + index2}
                        colSpan={field.colspan !== undefined ? field.colspan : 1}
                        className={classNames
                          .map((className) => {
                            return className
                          })
                          .join(" ")}
                      >
                        {value.map((val, index) => {
                          return <span key={index}>{val}</span>
                        })}
                      </td>
                    )
                  })}
                </tr>
              )
            })
          )}
        </tbody>
      </Table>
    )
    this.dMgr.renderDone()
    return toRender
  }
}

export default withHooks(TableOfEntities)
